import {
    ModalState,
} from '../../common/types/reducers';
import {StepViewState, UIState} from '../types/mx/reducers';
import {modalInit} from './ModalInit';
import {AlertProps} from '../../common/types/components';

export const uIInit: UIState = {
    modal: modalInit as ModalState,
    alert: {
        alertList: []
    } as AlertProps,
    loader: [],
    stepView: {
        steps: []
    } as StepViewState
};